import { Button, Flex, SafeHtml, Text } from "@coaching-culture/ui";
import { animated, useTrail } from "react-spring";

export type ContentProps = {
  index: number;
  count: number;
  title: string;
  content: string;
  onConfirm: () => void;
  reverse: boolean;
  sectionName: string | null;
};

export const Content = ({
  index,
  count,
  title,
  content,
  onConfirm,
  reverse,
  sectionName,
}: ContentProps) => {
  let trail = useTrail(3, {
    from: {
      y: 100 * (reverse ? -1 : 1),
      opacity: 0,
    },
    to: {
      y: 0,
      opacity: 1,
    },
  });

  if (reverse) {
    trail.reverse();
  }

  return (
    <Flex flexDirection="column" mb={3}>
      <animated.div style={trail[0]}>
        <Text fontWeight={500} color="textMuted" fontSize="small">
          {sectionName ? `${sectionName} - ` : ""} {index + 1} / {count}
        </Text>
        <Text mb={[2, 3]} fontSize="section" fontWeight={600} color="black">
          {title}
          &nbsp;
        </Text>
      </animated.div>
      <animated.div style={trail[1]}>
        <SafeHtml html={content} />
      </animated.div>
      <animated.div style={trail[2]}>
        <Flex justifyContent="center">
          <Button onClick={onConfirm} color="primary">
            Continue
          </Button>
        </Flex>
      </animated.div>
    </Flex>
  );
};
